module.exports = __webpack_public_path__ + "openhand.b06c243f534d9c5461d1.cur";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/revolution_slider/css/openhand.cur
// module id = ../../../../../src/assets/components/revolution_slider/css/openhand.cur
// module chunks = 2